module.exports = __webpack_public_path__ + "static/media/Kitamo.079dc220.png";